/**
 * OverlayState is a bag of values for either the initial configuration or current state of an
 * overlay.
 */
export var OverlayState = (function () {
    function OverlayState() {
        /** Whether the overlay has a backdrop. */
        this.hasBackdrop = false;
        /** Custom class to add to the backdrop **/
        this.backdropClass = 'cdk-overlay-dark-backdrop';
        /** The direction of the text in the overlay panel. */
        this.direction = 'ltr';
    }
    return OverlayState;
}());

//# sourceMappingURL=overlay-state.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@angular/material/core/overlay/overlay-state.js
// module id = ./node_modules/@angular/material/core/overlay/overlay-state.js
// module chunks = vendor